import httpClient from '@/libs/http-client'

// 컴퍼니 상세 정보
export function partnerDetail(data) {
  const url = '/api/admin/partner/detail'
  return httpClient.post(url, data).then(response => {
    return response.data
  })
}
// 컴퍼니 정보 수정
export function partnerModify(data) {
  const url = '/api/super/company/modify/compInfo'
  return httpClient.post(url, data).then(response => {
    return response.data
  })
}

// 컴퍼니 정보 수정
export function partnerPassUpdate(data) {
  const url = '/api/admin/partner/passChg'
  return httpClient.post(url, data).then(response => {
    return response.data
  })
}
// 컴퍼니 정보 수정
export function partnerOtpUpdate(data) {
  const url = '/api/admin/partner/otpChg'
  return httpClient.post(url, data).then(response => {
    return response.data
  })
}
